import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=a640bb86&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=a640bb86&prod&scoped=true&lang=css"
import style1 from "./HomeLayout.vue?vue&type=style&index=1&id=a640bb86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a640bb86",
  null
  
)

export default component.exports